import axios from 'axios'
import {
  MessageBox,
  Message,
  Notification
} from 'element-ui'

// create an axios instance
const service = axios.create({
  baseURL: 'https://help.listeneer.com/api/',
  timeout: 60000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data
    // console.log(res);

    // if the custom code is not 20000, it is judged as an error.
    if (res.code !== 1) {
      return Promise.reject(new Error(res.msg || 'Error'))
    } else {
      return res
    }
  },
  error => {
    Notification({
      type: "error",
      title: '错误',
      message: error.message || 'Error'
    });
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js